export default {
  user: {
    profile: "Profile",
    user: "User",
    users: "Users",
    user_list: "User List",
    role_list: "Role List",
    username: "User Name",
    name: "Full Name",
    email: "Email",
    phone: "Phone",
    add: "Add User",
    password: "Password",
    repeat_password: "Repeat password",
    login: "Login",
    department: "Department",
    position: "Position",
    role: "Role",
    status: "Status",
    usernameExist: "Username is already existed",
    emailExist: "Email is already existed",
    contact: "Contact Information"
  }
};
